document.addEventListener('DOMContentLoaded', function () {
  var slider    = document.querySelector('.js-ts-slider');
  if (!slider) return;

  var wrapper   = slider.querySelector('.swiper-wrapper');
  var slides    = slider.querySelectorAll('.swiper-slide');
  var prevBtn   = document.querySelector('.js-ts-prev');
  var nextBtn   = document.querySelector('.js-ts-next');
  var currentEl = document.querySelector('.js-ts-current');
  var total     = slides.length;
  var current   = 0;

  function setup() {
    var w = slider.offsetWidth;
    slider.style.overflow   = 'hidden';
    wrapper.style.display   = 'flex';
    wrapper.style.transition = 'none';
    wrapper.style.width     = (w * total) + 'px';
    slides.forEach(function (slide) {
      slide.style.width      = w + 'px';
      slide.style.flexShrink = '0';
      slide.style.boxSizing  = 'border-box';
    });
    // Re-snap to current slide without animation after resize
    wrapper.style.transform = 'translateX(-' + (current * w) + 'px)';
    // Re-enable transition after the snap
    requestAnimationFrame(function () {
      wrapper.style.transition = 'transform 0.4s ease';
    });
  }

  function goTo(index) {
    current = (index + total) % total;
    wrapper.style.transform = 'translateX(-' + (current * slider.offsetWidth) + 'px)';
    if (currentEl) {
      currentEl.textContent = String(current + 1).padStart(2, '0');
    }
  }

  setup();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setup, 100);
  });

  if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });
});
